export default "__VITE_ASSET__DkOUuDtB__"